var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-check",
    x: 0,
    y: 0,
    width: 23.998,
    height: 23.998,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-check1",
    serifid: "iconB-check"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.293,5.293c0.39,-0.39 1.024,-0.39 1.414,-0c0.39,0.39 0.39,1.024 0,1.414l-11,11c-0.39,0.391 -1.024,0.391 -1.414,0l-5,-5c-0.39,-0.39 -0.39,-1.024 -0,-1.414c0.39,-0.39 1.024,-0.39 1.414,-0l4.293,4.293l10.293,-10.293Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBCheck);
export default __webpack_public_path__ + "static/media/iconB-check.07ed1312621a60c39cf6d45cef829e12.svg";
export { ForwardRef as ReactComponent };